<template>
    <div class="criar-user-form">
        <form
            @submit.prevent="sendData(routine)"
            class="form-module admin-backoffice-form"
            method="post"
            action=""
            aria-describedby="Create Customer Card Plans"
            enctype="application/x-www-form-urlencoded"
            autocomplete="on"
        >
            <!-- Detalhes pessoais -->
            <div class="input-row">
                <fieldset>
                    <legend class="heading-6">Detalhes pessoais</legend>

                    <!-- Nome -->
                    <div class="input-row-item">
                        <div
                            data-reference="firstname"
                            class="item-label-input"
                        >
                            <label
                                for="firstname"
                                class="form-label body-1 strong-600"
                                >Nome*</label
                            >
                            <input
                                type="text"
                                @focusin="inputValidationCase('firstname')"
                                @focusout="inputValidationCase('firstname')"
                                v-model="firstname"
                                class="form-control body-1"
                                id="firstname"
                                placeholder="Nome"
                                maxlength="100"
                            />
                        </div>
                    </div>

                    <!-- Apelido -->
                    <div class="input-row-item">
                        <div data-reference="lastname" class="item-label-input">
                            <label
                                for="lastname"
                                class="form-label body-1 strong-600"
                                >Apelido*</label
                            >
                            <input
                                type="text"
                                @focusin="inputValidationCase('lastname')"
                                @focusout="inputValidationCase('lastname')"
                                v-model="lastname"
                                class="form-control body-1"
                                id="lastname"
                                placeholder="Apelido"
                                maxlength="100"
                            />
                        </div>
                    </div>

                    <!-- Email -->
                    <div class="input-row-item">
                        <div data-reference="email" class="item-label-input">
                            <label
                                for="email"
                                class="form-label body-1 strong-600"
                                >Email*</label
                            >
                            <input
                                type="email"
                                @focusin="inputValidationCase('email')"
                                @focusout="inputValidationCase('email')"
                                v-model="email"
                                class="form-control body-1"
                                id="email"
                                placeholder="Email"
                                maxlength="250"
                            />
                        </div>
                    </div>

                    <!-- Contato -->
                    <div class="input-row-item">
                        <div data-reference="contact" class="item-label-input">
                            <label
                                for="contact"
                                class="form-label body-1 strong-600"
                                >Contato</label
                            >
                            <input
                                type="text"
                                @focusin="inputValidationCase('contact')"
                                @focusout="inputValidationCase('contact')"
                                v-model="contact"
                                class="form-control body-1"
                                id="contact"
                                placeholder="Contato"
                                maxlength="9"
                            />
                        </div>
                    </div>
                </fieldset>
            </div>

            <!-- Tipo de utilizador -->
            <div class="input-row">
                <fieldset>
                    <legend class="heading-6">Tipo de utilizador</legend>

                    <div class="input-row-item">
                        <div data-reference="contact" class="item-label-input">
                            <label
                                for="contact"
                                class="form-label body-1 strong-600"
                                >Função</label
                            >
                            <input
                                type="text"
                                @focusin="inputValidationCase('position')"
                                @focusout="inputValidationCase('position')"
                                v-model="position"
                                class="form-control body-1"
                                id="position"
                                placeholder="Função"
                                maxlength="100"
                            />
                        </div>
                    </div>

                    <div class="input-row-item">
                        <div
                            data-reference="user_rule"
                            class="item-label-input"
                        >
                            <label
                                for="user_rule"
                                class="form-label body-1 strong-600"
                                >Permissão</label
                            >

                            <template v-if="customdata.length > 0">
                                <div
                                    v-for="(value, index) of customdata"
                                    class="form-check systemfunction-type"
                                    :key="index"
                                    :data-referindex="index"
                                >
                                    <input
                                        @click="selectFunction($event)"
                                        class="form-check-input"
                                        type="radio"
                                        name="systemfunction-type"
                                        :id="`systemfunction-type-unique-${index}`"
                                        :value="value.role"
                                    />
                                    <label
                                        class="form-check-label button-body first-option-label"
                                        :for="`systemfunction-type-unique-${index}`"
                                    >
                                        <p class="button-body">
                                            {{ value.name }}
                                        </p>
                                        <p class="caption-md color-text-body">
                                            {{ value.description }}
                                        </p>
                                    </label>
                                </div>
                            </template>
                        </div>
                    </div>
                </fieldset>
            </div>

            <!-- Submit Button -->
            <div class="input-row">
                <button
                    type="submit"
                    class="btn btn-primary btnsubmit button-body"
                    :disabled="disabled"
                >
                    {{
                        routine === "PUT"
                            ? "Editar utilizador"
                            : "Criar utilizador"
                    }}
                </button>

                <button
                    @click="turnBack(moduledefaultindex)"
                    type="button"
                    class="btn btncancel button-body"
                >
                    Cancelar
                </button>
            </div>
        </form>
    </div>
</template>
<script>
import fetchData from "./../../fetchData.js";
import inputValidation from "./../../validationInputs.js";
import ListMessage from "./../elements/ListMessageElement.vue";
import Loading from "./../elements/LoadingElement.vue";
import responseMessage from "./../../responseMessage.js";
import defaultWebsite from "./../../defaultWebsiteScript.js";

export default {
    name: "UserForm",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        routine: {
            type: String,
            required: true,
        },
        storedata: {
            type: String,
            required: false,
        },
        moduleindex: {
            type: String,
            required: true,
        },
        routineurl: {
            type: String,
            required: true,
        },
        moduledata: {
            type: Array,
            required: true,
        },
        customdata: {
            type: Array,
            required: false,
        },
        disabledreturn: {
            type: Boolean,
            required: true,
        },
        defaultsenddata: {
            type: Function,
            required: true,
        },
        moduledefaultindex: {
            type: String,
            required: false,
        },
    },
    data: () => {
        return {
            firstname: "",
            lastname: "",
            email: "",
            contact: "",
            position: "",
            user_rule: "",
            allStores: {},
            storeList: [],
            inputNotIsValid: true,
            activeclass: "d-flex",
            moduleData: [],
            disabled: true,
            action: "",
        };
    },
    created() {
        //Get data from Stores
        //this.allStores = JSON.parse(this.storedata);

        //Set Action Conditional
        this.action = this.routine === "POST" ? "create" : "update";

        //Set Customer Card Plan
        this.moduleData = this.moduledata;
    },
    mounted() {
        //Set Values for Update Routine
        this.setValuesForUpdate(this.moduleData);
    },
    methods: {
        turnBack(referurl) {
            defaultWebsite.turnBack(referurl);
        },
        selectFunction(element) {
            this.user_rule = element.currentTarget.value;
        },
        selectValue(element) {
            //Set System User Rule
            if (Number.isInteger(parseInt(element.target.value))) {
                this.user_rule = element.target.value;

                return this.user_rule;
            } else {
                if (element.target.value.includes("Escolha")) {
                    //Show Error Message
                    inputValidation.createErrorMessageElement(
                        element.target.getAttribute("id"),
                        "Por favor apenas escolher funções permitidas pelo sistema"
                    );
                }
            }
        },
        chooseStore(element) {
            //Store Element
            let storeElement = element.target.hasAttribute("data-storeid")
                ? element.target
                : element.target.parentElement;

            //Set active class and get store id
            if (!storeElement.classList.contains("active")) {
                //Check store id
                if (
                    this.storeList.includes(
                        storeElement.getAttribute("data-storeid")
                    )
                ) {
                    return;
                }

                //Check input Conditional
                this.disabled = this.inputNotIsValid;

                //Add Class
                storeElement.classList.add("active");

                //Push Store Id
                this.storeList.push(storeElement.getAttribute("data-storeid"));
            } else {
                //Remove Class
                storeElement.classList.remove("active");

                //Get Index from List
                let index = this.storeList.indexOf(
                    storeElement.getAttribute("data-storeid")
                );

                //Remove from store id list
                this.storeList.splice(index, 1);
            }
        },
        inputValidationCase(inputid) {
            //console.log(Object.entries(this.$data));

            //Check Inputs
            switch (inputid) {
                //Firstname
                case "firstname":
                    this.disabled = inputValidation.validNameCases(
                        3,
                        this.firstname
                    )
                        ? false
                        : true;

                    break;

                //Lastname
                case "lastname":
                    this.disabled = inputValidation.validNameCases(
                        3,
                        this.lastname
                    )
                        ? false
                        : true;

                    break;

                //Email
                case "email":
                    this.disabled = inputValidation.validNameCases(
                        7,
                        this.email
                    )
                        ? false
                        : true;

                    break;

                //Contact
                case "contact":
                    if (this.contact !== "") {
                        this.disabled = inputValidation.validNameCases(
                            2,
                            this.contact
                        )
                            ? false
                            : true;
                    }

                    break;

                //Position
                case "position":
                    if (this.position !== "") {
                        this.disabled = inputValidation.validNameCases(
                            3,
                            this.position
                        )
                            ? false
                            : true;
                    }

                    break;
            }

            //Set Conditional for input is valid
            this.inputNotIsValid = this.disabled;

            //Show Error Message
            if (this.disabled) {
                inputValidation.createErrorMessageElement(
                    inputid,
                    "Favor enviar dados válidos"
                );
            }
        },
        setValuesForUpdate(moduleData) {
            //Check Routine
            if (this.routine === "POST") {
                return;
            }

            //Set Name
            let userName = moduleData[0].user_name.split(" ");

            //Set Value
            this.firstname = userName[0];
            this.lastname = userName[1];
            this.email = moduleData[0].email;
            this.contact = moduleData[0].contact
                ? moduleData[0].contact.toString()
                : "";
            this.position = moduleData[0].position
                ? moduleData[0].position
                : "";
            this.user_rule = moduleData[0].user_rule
                ? moduleData[0].user_rule.toString()
                : "";

            //List All Stores Elements
            /*  let storesEl = [...document.querySelector('.baseformstore').children];

            storesEl.forEach((value) => {

                if(this.storeList.includes(parseInt(value.getAttribute('data-storeid')))){

                    //Add Class
                    value.classList.add('active');

                }

            }); */

            //List All System Roles
            let systemRoles = [
                ...document.getElementById("user_rule").children,
            ];

            systemRoles.forEach((valRole) => {
                if (parseInt(valRole.value) === parseInt(this.user_rule)) {
                    valRole.setAttribute("selected", true);
                } else {
                    if (valRole.hasAttribute("selected")) {
                        valRole.removeAttribute("selected");
                    }
                }
            });

            //Set Conditional
            this.inputNotIsValid = false;

            //Enabled Submit Button
            this.disabled = false;
        },
        sendData() {
            //When the input is empty
            if (
                this.firstname === "" ||
                this.lastname === "" ||
                this.email === "" ||
                this.user_rule === ""
            ) {
                //Render Response Message
                responseMessage.renderResponseMessages(
                    document.querySelector(".responsebasemessage"),
                    "warning",
                    "Necessário preencher os inputs indicados como obrigatórios",
                    this.activeclass,
                    this.responseTimeOut
                );

                this.disabled = true;

                return;
            }

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            let dataForm = {
                name: `${this.firstname.trim()} ${this.lastname.trim()}`,
                email: this.email.trim(),
                contact: this.contact !== "" ? this.contact.trim() : null,
                position: this.position !== "" ? this.position.trim() : null,
                rule: this.user_rule.trim(),
            };

            //Check Routine
            if (this.routine === "PUT") {
                dataForm.userid = this.moduleData[0].user_id;
            }

            //Send Data Routine
            this.defaultsenddata(
                this.routineurl,
                dataForm,
                this.routine,
                this.action
            );
        },
    },
    computed: {
        computedStoreList() {
            return this.storeList;
        },
        computedDisabled() {
            return this.disabled;
        },
        computedInputIsNotValid() {
            return this.inputNotIsValid;
        },
        computedStarStore() {
            return this.starstore;
        },
    },
    watch: {
        computedStoreList() {},
        computedDisabled() {},
        computedInputIsNotValid() {},
        computedStarStore() {},
    },
    components: {
        listMessage: ListMessage,
        loading: Loading,
    },
    beforeDestroy() {
        this.firstname = "";
        this.lastname = "";
        this.email = "";
        this.contact = "";
        this.position = "";
        this.user_rule = "";
    },
};
</script>
